import React, { type FC } from 'react'
import { Chip as BaseChip, type ChipProps, type SvgIconProps } from '@mui/material'

import type { Translation } from '../../../domain'

import { useTranslator } from '../Internationalization'

export const Chip = ({
    label,
    avatar: Avatar,
    sx,
    onClick,
    ...props
}: Readonly<{ label: Translation, avatar: FC<SvgIconProps> }> & Pick<ChipProps, 'sx' | 'onClick'>): ReturnType<FC> => {
    const translator = useTranslator()
    const title = translator.formatTranslation(label)

    return <BaseChip {...props} sx={sx} title={title} label={title} avatar={<Avatar />} variant="outlined" onClick={onClick} />
}
